import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  > * + * {
    margin-top: 40px;
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    > * + * {
      margin-top: 30px;
    }
  }
`;
